import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { ClienteAnaliseMercadoHeaderModule } from '../header';
import { GrupoClassificacaoSelectModule } from '../../grupo-classificacao/select';
import { GrupoClassificacaoClassificavelFormModule } from '../../grupo-classificacao/classificavel/form';
import { ClienteTypeaheadSharedModule } from '../../pessoa/cliente/typeahead';
import { CustomerShareIndicadorBadgeModule } from '../../pic/customer-share/indicador/badge';

import { ClienteAnaliseMercadoLancamentoFormComponent } from './form';
import { ClienteAnaliseMercadoLancamentoFormModalComponent } from './form-modal';
import { ClienteAnaliseMercadoLancamentoCreateModalComponent, ClienteAnaliseMercadoLancamentoClassificacaoCreateComponent } from './create';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoHeaderModule,
        GrupoClassificacaoSelectModule,
        GrupoClassificacaoClassificavelFormModule,
        ClienteTypeaheadSharedModule,
        CustomerShareIndicadorBadgeModule
    ],
    declarations: [
        ClienteAnaliseMercadoLancamentoFormComponent,
        ClienteAnaliseMercadoLancamentoFormModalComponent,
        ClienteAnaliseMercadoLancamentoCreateModalComponent,
        ClienteAnaliseMercadoLancamentoClassificacaoCreateComponent
    ],
    exports: [
        ClienteAnaliseMercadoLancamentoFormComponent,
        ClienteAnaliseMercadoLancamentoFormModalComponent,
        ClienteAnaliseMercadoLancamentoCreateModalComponent
    ]
})
export class ClienteAnaliseMercadoLancamentoModule { }
